import { createSlice } from '@reduxjs/toolkit';

import { IAppState, AppInitAction, AppSetConfigAction } from './types';

const initialState: IAppState = {
  isReady: false,
  isUnavailable: false,
  isUnauthorized: false,
  isLoginRedirect: true,
  config: null,
};

// TODO Refactor
const app = createSlice({
  name: '@app',
  initialState,
  reducers: {
    init: (state, action: AppInitAction) => {
      state.isLoginRedirect = action.payload.isLoginRedirect;
    },
    finish: (state) => {
      state.isReady = true;
    },
    unavailable: (state) => {
      state.isUnavailable = true;
    },
    unauthorized: (state) => {
      state.isUnauthorized = true;
    },
    setConfig: (state, action: AppSetConfigAction) => {
      state.config = action.payload;
    },
  },
});

export const APP_START_INIT = app.actions.init.type;
export const APP_FINISH_INIT = app.actions.finish.type;
export const APP_UNAVAILABLE = app.actions.unavailable.type;

export const {
  actions: {
    finish: appFinishInit,
    init: appStartInit,
    unavailable: appUnavailable,
    unauthorized: appUnauthorized,
    setConfig: appSetConfig,
  },
} = app;

export const appReducer = app.reducer;
